<template>
  <div class="container">

    <div class="menu-bar">
    <div class="left-group">
      <router-link to="/landing">
    	<section class="section-1">
    		<div class="title">
				<span data-desktop-color="rgba(0,97,249,1)" >60secondApps</span>
			</div>
			<div class="subtitle">
				<span data-desktop-color="rgba(0,97,249,1)" >Idea to web app in 60 seconds.</span>
			</div>
		</section>
      </router-link>
    
      <ul class="menu-list">
        <li class="menu-item">
          File
          <ul class="dropdown-menu">
            <li>New</li>
            <li>Open</li>
            <li>Save</li>
            <li>Save As</li>
            <li>Export</li>
          </ul>
        </li>
        <li class="menu-item">
          Edit
          <ul class="dropdown-menu">
            <li>Undo</li>
            <li>Redo</li>
            <li>Cut</li>
            <li>Copy</li>
            <li>Paste</li>
          </ul>
        </li>
        <li class="menu-item">
          View
          <ul class="dropdown-menu">
            <li>Toggle UI</li>
            <li>Zoom In</li>
            <li>Zoom Out</li>
            <li>Reset Zoom</li>
            <li>Full Screen</li>
          </ul>
        </li>
        <li class="menu-item">
          Data Model
          <ul class="dropdown-menu">
            <li>Add Entity</li>
            <li>Edit Entity</li>
            <li>Delete Entity</li>
            <li>Import Data</li>
            <li>Export Data</li>
          </ul>
        </li>
        <li class="menu-item">
          AI Actions
          <ul class="dropdown-menu">
            <li>Suggest Schema</li>
            <li>Generate Data</li>
            <li>Analyze Data</li>
            <li>Optimize Query</li>
            <li>Fix Errors</li>
          </ul>
        </li>
        <li class="menu-item">
          Cloud
          <ul class="dropdown-menu">
            <li>Configure AWS</li>
            <li>Configure Azure</li>
            <li>Configure GCP</li>
            <li>Deploy</li>
            <li>Manage</li>
          </ul>
        </li>
        <li class="menu-item">
          Settings
          <ul class="dropdown-menu">
            <li>Preferences</li>
            <li>Themes</li>
            <li>Keybindings</li>
            <li>Account</li>
            <li>Help</li>
          </ul>
        </li>
        <li class="menu-item">
          Team
          <ul class="dropdown-menu">
            <li>Invite</li>
            <li>Members</li>
            <li>Permissions</li>
            <li>Projects</li>
            <li>History</li>
          </ul>
        </li>
        <li class="menu-item">
          Help
          <ul class="dropdown-menu">
            <li>Documentation</li>
            <li>Tutorials</li>
            <li>FAQ</li>
            <li>Report Bug</li>
            <li>Contact Us</li>
          </ul>
        </li>
      </ul>
</div>
    <div :class="['links', { 'links--active': isMenuOpen }]">
      <nav class="nav">
        <router-link class="link" to="/create">Create</router-link>
        <router-link class="link" to="/my-apps">My Apps</router-link>
        <router-link class="link" to="/app-gallery">App Gallery</router-link>
        <router-link class="link" to="/pricing">Pricing</router-link>
		<router-link class="link" to="/sign-in">SignIn</router-link>
      </nav>
      <div class="avator">
        <router-link class="link" to="/sign-in">
          <img src="../assets/avator.jpeg" alt="avator" />
        </router-link>
      </div>
    </div>

    </div>



    
    <div :class="['main-content', activeTab === 'preview' ? 'code-mode' : 'preview-mode']">
    
      <div class="chat-window">
        <div class="chat-messages" ref="chatMessages">
<div
  v-for="(message, index) in messages"
  :key="index"
  :class="message.sender === 'user' ? 'user-message' : 'ai-message'"
  class="message-block"
>
  <div>
  	<span v-if="message.isTyping" class="spinner"></span>
    {{ message.text }}
    
  </div>
</div>
        </div>
        <div class="chat-input">
          <input type="text" v-model="newMessage" @keyup.enter="sendMessage" placeholder="Type your message...">
          <button @click="sendMessage">Send</button>
        </div>
      </div>
      <div class="right-panel">
        <div class="panel-tabs">
          <button v-if="Object.keys(applicationDetails).length > 0" :class="{ active: activeTab === 'details' }" @click="activeTab = 'details'">Details</button>
          <button v-if="showPreviewTab" :class="{ active: activeTab === 'preview' }" @click="activeTab = 'preview'">Preview</button>
          <button v-if="showCodeTab" :class="{ active: activeTab === 'code' }" @click="activeTab = 'code'">Code</button>
          
          <div style="margin-left: auto; margin-right: 15px; position: relative; top: 5px; cursor: pointer;" @click="openPreview"
          @mouseover="showTooltip = true"
          @mouseleave="showTooltip = false">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line></svg>
          <div v-if="showTooltip" style="position: absolute; top: 30px; right: -10px; background-color: rgba(0, 0, 0, 0.8); color: white; padding: 5px 10px; border-radius: 4px; font-size: 12px; white-space: nowrap;">Open fullpage</div>
        </div>
        </div>
        <div class="panel-content">
          <div v-if="activeTab === 'code'" class="code-editor">
				
				<div class="iframe-container">
				</div>
            
				<div v-for="n in 1000" :key="n">
              		{{ n }}: {{ sampleCode }}
				</div>
          </div>





<div v-if="activeTab === 'preview'" class="grid-container">

          <iframe v-if="activeTab === 'preview'" class="preview-iframe"
          		:src="iframeUrl1"
			  	:key="iframeUrl1"
			  ></iframe>
<!--          
          <iframe v-if="activeTab === 'preview'" class="preview-iframe"
          		:src="iframeUrl2"
			  	:key="iframeUrl2"
			  ></iframe>
          
          <iframe v-if="activeTab === 'preview'" class="preview-iframe"
          		:src="iframeUrl3"
			  	:key="iframeUrl3"
			  ></iframe>
          
          <iframe v-if="activeTab === 'preview'" class="preview-iframe"
          		:src="iframeUrl4"
			  	:key="iframeUrl4"
			  ></iframe>
			  
			  -->
</div>

			<div v-if="activeTab === 'details'">
				<div class="table-container">

					<table>
						<tr> 
						<td class="detail_view_column_2">Github Repo</td>
							<td class="detail_view_column_1"><b> 
							           <a :href="`https://github.com/60secondAppsAI/${applicationDetails.applicationName}-0001`" target="_blank">
							                {{ applicationDetails.applicationName }}-0001
							            </a> 
							</b></td>
						</tr>
						<tr> 
						<td class="detail_view_column_2">Deployment URL</td>
							<td class="detail_view_column_1"><b> 
							           <a :href="`https://${applicationDetails.deploymenturl}`" target="_blank">
							                {{applicationDetails.deploymenturl}}
							            </a> 
							</b></td>
						</tr>
						<tr> 
							<td class="detail_view_column_2">Application Id</td>
																								    		<td class="detail_view_column_1"><b> {{ applicationDetails.applicationId }} </b></td>
						    						    														</tr>
							<tr>
					<td>
						<div>Application Name</div>		
					</td>
					<td  class="detail_view_column_1">
						<div>
						  <div>
							      <div>
							        <b>{{applicationDetails.applicationName}}</b>
							      </div>
						  </div>
						</div>  
					</td>
				</tr>
	
																											<tr> 
						<td class="detail_view_column_2">Package Name</td>
											    <td class="detail_view_column_1">
								<div class="detail_view_input" style="display: inline-flex;">
																			<input label="PackageName" type="text" placeholder="Enter PackageName" v-model="applicationDetails.packageName"></input>
																			</div>
							</td>
															</tr>
																<tr> 
						<td class="detail_view_column_2">Package Path</td>
											    <td class="detail_view_column_1">
								<div class="detail_view_input" style="display: inline-flex;">
																			<input label="PackagePath" type="text" placeholder="Enter PackagePath" v-model="applicationDetails.packagePath"></input>
																			</div>
							</td>
															</tr>
																<tr> 
						<td class="detail_view_column_2">Application Top Long</td>
											    <td class="detail_view_column_1">
								<div class="detail_view_input" style="display: inline-flex;">
																			<input label="ApplicationTopLong" type="text" placeholder="Enter ApplicationTopLong" v-model="applicationDetails.applicationTopLong"></input>
																			</div>
							</td>
															</tr>
																<tr> 
						<td class="detail_view_column_2">Application Sidebar Long</td>
											    <td class="detail_view_column_1">
								<div class="detail_view_input" style="display: inline-flex;">
																			<input label="ApplicationSidebarLong" type="text" placeholder="Enter ApplicationSidebarLong" v-model="applicationDetails.applicationSidebarLong"></input>
																			</div>
							</td>
															</tr>
																<tr> 
						<td class="detail_view_column_2">Database Name</td>
											    <td class="detail_view_column_1">
								<div class="detail_view_input" style="display: inline-flex;">
																			<input label="DatabaseName" type="text" placeholder="Enter DatabaseName" v-model="applicationDetails.databaseName"></input>
																			</div>
							</td>
															</tr>
																<tr> 
						<td class="detail_view_column_2">Image File</td>
											    <td class="detail_view_column_1">
								<div class="detail_view_input" style="display: inline-flex;">
																			<input label="ImageFile" type="text" placeholder="Enter ImageFile" v-model="applicationDetails.imageFile"></input>
																			</div>
							</td>
																	<td class="detail_view_column_3">
							</td>
															
							<td class="detail_view_column_4">
							</td>
										</tr>
																<tr> 
						<td class="detail_view_column_2">Front End</td>
											    <td class="detail_view_column_1">
								<div class="detail_view_input" style="display: inline-flex;">
	                    				<img class="database-image" :src="`/images/vuejs.png`" />
	                          <!--  <input label="DatabaseType" type="text" placeholder="Enter DatabaseType" v-model="applicationDetails.databaseType"></input> -->
																			</div>
							</td>
															</tr>
																<tr> 
						<td class="detail_view_column_2">Back End</td>
											    <td class="detail_view_column_1">
								<div class="detail_view_input" style="display: inline-flex;">
	                    				<img class="database-image" :src="`/images/javaspringboot.png`" />
	                          <!--  <input label="DatabaseType" type="text" placeholder="Enter DatabaseType" v-model="applicationDetails.databaseType"></input> -->
																			</div>
							</td>
															</tr>
						<tr> 
							<td class="detail_view_column_2">Database Type</td>
											    <td class="detail_view_column_1">
								<div class="detail_view_input" style="display: inline-flex;">
	                    				<img class="database-image" :src="`/images/mariadb.png`" />
	                          <!--  <input label="DatabaseType" type="text" placeholder="Enter DatabaseType" v-model="applicationDetails.databaseType"></input> -->
																			</div>
							</td>
						</tr>
							
	
		
					
													</table>												
												</div>
													
				</div>


          
        </div>  
      </div>
    </div>













  </div>
</template>

<script>

import UserService from "../services/UserService";
import ApplicationService from "../services/ApplicationService";

export default {
  data() {
    return {

		isMenuOpen: false,
		
		applicationDetails: { },
		showPreviewTab: false,
		showCodeTab: false,
    
		  messages: [],
          showTooltip: false,
          newMessage: '',
          activeTab: '',
          sampleCode: 'sample code here' ,
		rememberMe: true,
      applicationToAdd: {
        creationPrompt: '',
        frontEnd: 'VueJS',  // default selection
        backEnd: 'Spring Boot',  // default selection
        database: 'MariaDB'  // default selection
      },
	    resultMessage: '', // Message to display after the server responds
	    okButtonEnabled: true, // Enables 'OK' button once response is received
	    taskCompletion: [false, false, false, false, false, false, false],
messages: [],
createMessages: [
  { text: "Constructing your data model... We'll take a first pass and create 20 distinct entity classes which best suit your application. Don't worry, we can iterate over this as many times as you like.", sender: 'ai' },
  { text: "Building your database specs... Next, We'll use your data model to create a database and populate it with mock data.  ", sender: 'ai' },
  { text: "Creating your application... Now, let's setup your data model in our codegen configurator.  Looking good so far! Time to generate some code! ", sender: 'ai' },
  { text: "Generating your code... Our AI code generator is unbeatable. We are creating both a backend and front end. For this initial version of your application, we are using Java Spring Boot and VueJS.", sender: 'ai' },
  { text: "Your code is complete! We're sharing your code via Github now...", sender: 'ai' },
  { text: "Starting deployment... We will build the java app using maven and deploy it to one of our servers. The Vue application and the database we'll be deployed there as well. Your full stack mini-service will be up and running in no time.", sender: 'ai' },
],
    };
  },
  created() {
    // Check for authToken in localStorage
    const authToken = localStorage.getItem('authToken');
    if (!authToken) {
      // Redirect to the sign-up page if the token is not found
      console.log("redirecting to SignUp");
      this.$router.push({ name: 'Sign-Up' }); // Adjust the route name as needed
    }
    else {
    	console.log("NOT redirecting to Sign-Up");
    }
    //this.iframeUrl1 = `https://60secondapps-0006.vip/?cacheBust=${Date.now()}`;
    //this.iframeUrl2 = `https://60secondapps-0006.vip/#/mydashboard/?cacheBust=${Date.now()}`;
    //this.iframeUrl3 = `https://60secondapps-0015.vip`;
    //this.iframeUrl4 = `https://60secondapps-0015.vip/#/mydashboard/?cacheBust=${Date.now()}`;
    
  },
	methods: {
    async getApplicationDetails(applicationId) {
		try {
			let response = await ApplicationService.get(applicationId);
			this.activeTab = 'details';
			this.applicationDetails = response.data;
		} catch {
		}
	},

	startIframeRefresh() {
	    // Begin interval-based refreshing
	    this.refreshIntervalId = setInterval(() => {
	      const url = new URL(this.iframeUrl1 || 'https://your-iframe-url.com');
	      url.searchParams.set('refresh', Date.now()); // Cache-busting param
	    }, 5000); // Refresh every 5 seconds
	
	    // Schedule stop after 60 seconds
	    this.stopTimeoutId = setTimeout(() => {
	      this.stopIframeRefresh();
	    }, 60000); // Stop after 60 seconds
	
	    console.log('Started iframe auto-refresh.');
	},
		
	stopIframeRefresh() {
	    if (this.refreshIntervalId) {
	      clearInterval(this.refreshIntervalId);
	      this.refreshIntervalId = null;
	    }
	
	    if (this.stopTimeoutId) {
	      clearTimeout(this.stopTimeoutId);
	      this.stopTimeoutId = null;
	    }
	
	    console.log('Stopped iframe auto-refresh after 60 seconds.');
	},	  

	scrollToBottom() {
      const container = this.$refs.chatMessages;
      if (container) {
        container.scrollTop = container.scrollHeight;
      }
    },

	sendMessage() {
        
		this.applicationToAdd.creationPrompt = this.newMessage;
		this.handleAddSubmitted();
			
        if (this.newMessage.trim() !== '') {
			this.messages.push({
            text: this.newMessage,
            sender: 'user'
        	});
            
					this.createMessages.forEach((msg, index) => {
					  setTimeout(() => {
					    const message = {
					      text: '',
					      fullText: msg.text,
					      sender: msg.sender,
					      isTyping: true
					    };
					
					    this.messages.push(message);
					
					    let charIndex = 0;
					    const typingInterval = setInterval(() => {
					      message.text += msg.text[charIndex];
					      charIndex++;
							
							this.scrollToBottom();
					      
					      if (charIndex === msg.text.length) {
					        clearInterval(typingInterval);
					        message.isTyping = false; // stop showing spinner
					        
							if (index === this.createMessages.length - 1) {
							  this.showPreviewTab = true;
							  this.activeTab = 'preview';
							  this.startIframeRefresh();
							}
					        
					      }
					    }, 30); // adjust typing speed here
					  }, index * 7000); // delay between messages
					});
            
        	this.newMessage = '';
        }
	},

        openPreview() {
          window.open('https://60secondapps-0006.vip', '_blank');
        },

	  spinnerClass(index) {
	    return this.taskCompletion[index] ? 'completed-check' : 'loading-spinner';
	  },	  
  	  async handleAddSubmitted() {
	    // Show the popup and start the loading spinner
	    this.okButtonEnabled = true;
	    this.resultMessage = '';
	
	    const currentDate = new Date().getTime();
	    this.applicationToAdd.created = currentDate;
	    
	    const jsonData = JSON.stringify(this.applicationToAdd);
	    
	    try {
	      const response = await ApplicationService.addApplication(jsonData);
	      const applicationId = response.data.applicationId;
	      this.getApplicationDetails(applicationId);
	
	
	    } catch (error) {
	      this.resultMessage = 'An error occurred. Please try again later.';
	      this.okButtonEnabled = true;
	    }
	  }
	},
computed: {
  iframeUrl1() {
  
  	let url =  null;
  	
    if (this.applicationDetails && this.applicationDetails.deploymenturl) {
    	url = ('https://' + this.applicationDetails.deploymenturl);
    }
    console.log(url);
    return url;
  }
}
	
};
</script>


<style scoped>
    .container {
    font-size: 1.05rem;
      font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
      margin: 0;
      display: flex;
      flex-direction: column;
      background-color: #282c34;
      color: #fff;
      height: 100vh;
      overflow: hidden;
    }

    #app {
      display: flex;
      width: 100%;
      height: 100%;
      flex-direction: column;
    }

    /* Menu Styles */
    .menu-bar {
      background-color: #353b48;
      color: #fff;
      padding: 8px;
      display: flex;
      align-items: center;
      width: 100%;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
      z-index: 10;
    }

    .menu-list {
      display: flex;
      list-style: none;
      padding: 0;
      margin: 0;
      align-items: center;
    }

    .menu-item {
      padding: 8px 12px;
      cursor: pointer;
      position: relative;
      transition: background-color 0.2s;
    }

    .menu-item:hover {
      background-color: #4a5464;
    }

    .dropdown-menu {
      position: absolute;
      top: 100%;
      left: 0;
      background-color: #303841;
      border: 1px solid #444;
      border-radius: 4px;
      padding: 5px 0;
      display: none;
      min-width: 160px;
      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
    }

    .menu-item:hover .dropdown-menu {
      display: block;
    }

    .dropdown-menu li {
      padding: 8px 16px;
      cursor: pointer;
      color: #d3d7de;
      transition: background-color 0.2s;
      list-style: none;
    }

    .dropdown-menu li:hover {
      background-color: #4a5464;
    }

    .main-content {
      display: flex;
      flex: 1;
      overflow: hidden;
    }

    .chat-window {
      flex: 1;
      display: flex;
      flex-direction: column;
      border-right: 1px solid #444;
      max-width: 30%;
      min-width: 30%;
      height: 100%;
    }

    .chat-messages {
      flex: 1;
      padding: 10px;
      overflow-y: auto;
      background-color: #3e4451;
    }

    .ai-message {
      background-color: #303841;
      color: #d3d7de;
      padding: 8px 5px;
      margin: 15px;
      border-radius: 8px;
      align-self: flex-start;
      box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
      word-break: break-word;
      max-width: 70%;
    }

    .user-message {
      background-color: #e9ecef;
      color: #212529;
      padding: 8px 5px;
      margin: 15px;
      border-radius: 8px;
      align-self: flex-end;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
      word-break: break-word;
      max-width: 70%;
      margin-left: auto;
    }

    .chat-input {
      padding: 15px;
      border-top: 1px solid #444;
      display: flex;
      background-color: #353b48;
    }

    .chat-input input {
      flex: 1;
      padding: 10px;
      border-radius: 8px;
      color: #f8f9fa;
      background-color: #4a5464;
      border: none;
      outline: none;
    }

    .chat-input button {
      padding: 10px 16px;
      background-color: #3498db;
      color: white;
      border: none;
      border-radius: 8px;
      cursor: pointer;
      margin-left: 5px;
      transition: background-color 0.3s ease;
    }

    .chat-input button:hover {
      background-color: #2980b9;
    }

    .right-panel {
      flex: 1;
      display: flex;
      flex-direction: column;
      background-color: #343a40;
      height: 100%;
      overflow: hidden;
    }

    .panel-tabs {
      display: flex;
      border-bottom: 1px solid #444;
    }

    .panel-tabs button {
      padding: 10px 16px;
      border: none;
      background-color: transparent;
      color: #adb5bd;
      cursor: pointer;
      border-bottom: 3px solid transparent;
      transition: color 0.3s ease, border-bottom-color 0.3s ease;
    }

    .panel-tabs button.active {
      color: #fff;
      border-bottom-color: #3498db;
    }

    .panel-tabs button:hover {
      color: #fff;
    }

    .panel-content {
      flex: 1;
      padding: 15px;
      color: #eee;
      overflow-y: auto;
    }

    .code-editor {
      font-family: 'Courier New', monospace;
      white-space: pre-wrap;
      overflow-wrap: break-word;
      line-height: 1.6;
    }

    .preview-iframe {
      width: 100%;
      height: 100%;
      border: none;
      border-radius: 8px;
      overflow: hidden;
    }
.container {
    margin-top: -70px;
  display: flex;
  flex-direction: column;
  height: 100vh; /* fill full viewport height */
  overflow: hidden;
}

.main-content {
  display: flex;
  flex: 1;
  overflow: hidden; /* avoid scrollbars */
}

.chat-window {
  width: 60%;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #444;
  height: 100%;
  overflow: hidden;
}

.chat-messages {
  flex: 1;
  overflow-y: auto;
  padding: 10px;
}

.chat-input {
  display: flex;
  padding: 10px;
  background-color: #1f1f1f;
}

.chat-input input {
  flex: 1;
  padding: 6px;
  margin-right: 10px;
}

.right-panel {
  width: 40%;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.panel-content {
  flex: 1;
  overflow-y: auto;
}

.preview-iframe {
  width: 100%;
  height: 100%;
  border: none;
}

.code-editor,
.user-message,
.ai-message {
  text-align: left;
}

.iframe-container {
	border-radius: 20px;
}
.panel-content {
  display: flex;
  gap: 10px;
  height: 100%; /* ensure enough height */
}

.preview-iframe {
  flex: 1;
  height: 80vh; /* adjust height as needed */
  border: 1px solid #ccc;
}

.grid-container iframe {
  width: 100%;
  height: 100%;
  border: none;
}
.container {
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
  overflow-y: auto;
}

.main-content.code-mode {
  overflow-y: auto;
}

.main-content.preview-mode {
  overflow-y: hidden;
}





.container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden; /* prevent scroll unless explicitly needed */
}
.main-content {
  flex: 1;
  display: flex;
  overflow: hidden;
}
.right-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.panel-content {
  flex: 1;
  overflow: hidden; /* default */
  display: flex;
  flex-direction: column;
}

.code-editor {
  overflow-y: auto;
  height: 100%;
  padding: 16px;
}
.grid-container {
  display: grid;
  /* grid-template-columns: repeat(2, 1fr);	*/
  /* grid-template-rows: repeat(2, 1fr); 	*/
  gap: 10px;
  flex: 1;
  padding: 10px;
  box-sizing: border-box;
  height: 100%;
  overflow: hidden;
}
/* .grid-container {
  display: grid;
  grid-template-columns: 1fr 1fr;    /* 2 columns 
  grid-template-rows: repeat(4, 1fr); /* 4 equal-height rows 
  gap: 10px;                         /* Optional spacing 
  width: 100%;
  height: 100vh;                     /* Full screen height 
  box-sizing: border-box;
}*/


.preview-iframe {
  width: 100%;
  height: 100%;
  border: 1px solid #ccc;
}


.section-1 {
  line-height: 34px;
  background-color: #353b48ff;
  color: #d3d7de !important;
  text-align: center;
  font-weight: 500;
  opacity: 1;
  font-size: 42px;
  font-style: italic;
  margin-top: 10px;
  margin-left: 10px;
  margin-right: 15px;
}

.section-1 .subtitle {
  background-color: #353b48ff;
  color: #d3d7de !important;
  text-align: center;
  font-weight: 400;
  opacity: 1;
  font-size: 21px;
  font-style: italic;
}

.spinner {
  margin-left: 10px;
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 3px solid rgba(0,0,0,0.1);
  border-top: 3px solid #3498db;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.message-block {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.message-text {
  font-family: monospace;
}

.links {
  display: flex;
  align-items: center;
  margin-left:200px;
}

.avator img {
  width: 40px;
  height: 40px;
  border-radius: 20px;
  border: 1px solid #ccc;
}

.hamburger {
  display: none;
  font-size: 30px;
  cursor: pointer;
}

.link {
  margin-right: 1.5rem;
  color: #d3d7de;
/* text-transform: uppercase; */
  text-decoration: none;
  font-weight: bold;
  font-size: 14px;
}

.menu-bar {
  display: flex;
  align-items: center;
  justify-content: space-between; /* push left and right groups apart */
  padding: 0 16px;
}
.left-group {
  display: flex;
  align-items: center;
  gap: 24px; /* optional spacing between section and menu */
}


.detail_view_input input {
	text-align: center;
}

.detail_view_column_1 {
	width: 250px; 
	text-align: center;
}
.detail_view_column_2 {
	min-width: 250px; 
}
.input {
	text-align: center;
}
#autosuggest__input {
  display: inline-block;
}
.autosuggest__results-container {
	position: relative;
}
.autosuggest__results {
	font-weight: 300;
	margin: 0;
	position: absolute;
	z-index: 10000001;
	border: 1px solid #e0e0e0;
	border-bottom-left-radius: 4px;
	border-bottom-right-radius: 4px;
	background: white;
}
.autosuggest__results ul {
	list-style: none;
	padding-left: 0;
	margin: 0;
}
.autosuggest__results .autosuggest__results-item {
	cursor: pointer;
	padding: 5px;
}
#autosuggest ul:nth-child(1) > .autosuggest__results_title {
	border-top: none;
}
.autosuggest__results .autosuggest__results_title {
	color: gray;
	font-size: 11px;
	margin-left: 0;
	padding: 15px 13px 5px;
	border-top: 1px solid lightgray;
}
.autosuggest__results .autosuggest__results-item:active,
.autosuggest__results .autosuggest__results-item:hover,
.autosuggest__results .autosuggest__results-item:focus,
.autosuggest__results
.autosuggest__results-item.autosuggest__results-item--highlighted {
	background-color: #F6F6F6;
}

.application-image {
	    height: 45px;
}

.inline-item {
  display: inline-block;
  margin-right: 100px; /* Adjust margin as needed */
}

.switch-container {
	width: 215px; 
    text-align: right;
    margin-right: 15px;
    margin-top: 5px;
    margin-bottom: 5px;
}

.btn_apps {
	width: 200px;	
}

.btn-starterup {
  display: inline-block;
  width: 200px;
    margin-top: 25px;
  padding: 12px 20px;
  font-size: 18px;
  color: #fff;
  background-color: #7b7b7b;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.btn-starterup:hover {
  background-color: #0056b3;
}
.domain-class-card {
    max-width: 160px;
    min-width: 160px;
    border-radius: 30px;
    padding: 0px;
    margin-bottom: 25px;
    /* Separate each card */
}

.card-container {
    display: flex;
    column-gap: 15px;
    flex-wrap: wrap;
    margin: 5px;
}

.domain-class-card {
  position: relative; /* Position relative to allow absolute positioning of the tooltip */
}

.domain-class-link {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 150px;
  height: 40px;
  left: 50%;
  border-radius: 4px;
  background-color: #7b7b7b;  
  color: #fff;
}

.domain-class-link:hover {
  background-color: #0056b3;
  color: #fff;
  pointer-events: none;
}

.database-image {
    height: 50px
}

.integration-image {
    height: 70px;
    padding: 10px;
}

.content {
    margin-top: 10px
}
.ant-tabs-nav-wrap {
  display: flex;
  justify-content: flex-start;
}

.ant-tabs-nav-list {
  width: auto !important;
}

.text-file-content {
margin-left: 75px;
  text-align: left; /* Ensures text is left-aligned */
  white-space: pre-wrap; /* Preserves formatting and wraps lines if necessary */
  font-family: monospace; /* Optional: Use a monospace font for better readability */
}

.application-image-table {
  width: 100%; /* Ensure the table takes the full width */
  max-width: 1200px;
}

.centered-cell {
  text-align: center; /* Center content in the cell */
}

.application-image {
  height: 45px; /* Maintain aspect ratio */
  margin-top: 50px;
}

.menu-bar {
	margin-top: 10px;
}
  </style>


